import styled from 'styled-components';

export const AssignmentRuleContainer = styled.div<{ $expanded: boolean }>`
  gap: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${({ $expanded }) => ($expanded ? '16px' : '')};
`;
